import React, { useContext } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { useUserSettings } from "components/Site/Contexts/UserSettings";

import { useAuthContext } from "../Auth/AuthContext";
import FacebookIcon from "icons/FacebookIcon";
import HomeIcon from "icons/HomeIcon";
import InfoIcon from "icons/InfoIcon";
import PeopleMan1Icon from "icons/PeopleMan1Icon";
import TwitterIcon from "icons/TwitterIcon";
import Media from "../../utils/media";
import { AppContext } from "components/App/AppProvider";
import { Site } from "../../api/typedefs/Site";
import { Theme } from "../../typedefs-ui/Theme";
import { isMobileDevice } from "utils/mobile";

const LinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${Media.desktop`
    flex-direction: row;
  `};
`;

const styleLink = `
  flex: 0 1 auto;
  padding: 0.4em 0.5em;
  margin-right: 10px;
  display: inline-block;
  ${Media.tablet`
    border: none;
    margin: 0;
  `};
`;
const IconAnchor = styled.a`
  ${styleLink}
`;
export const IconLink = styled(Link)`
  ${styleLink}
`;

const IconDividerWrapper = styled.div`
  margin-right: 8px;
  height: 100%;
  display: flex;
  align-items: center;
`;
const IconDivider = styled.div`
  width: 1px;
  height: 24px;
  background: rgba(255, 255, 255, 0.4);
`;

interface SiteLinksProps {
  site: Site;
  theme: Theme;
}

export const SiteLinks: React.FC<SiteLinksProps> = ({ site, theme }) => {
  const { isAuthenticated } = useAuthContext();
  const { darkMode } = useUserSettings();
  const { toggleDrawer } = useContext(AppContext);
  const isMobile = isMobileDevice();

  if (!site) return null;

  const hasSiteLinks =
    site.linkWebsite ||
    site.description ||
    site.linkFacebook ||
    site.linkTwitter;
  const iconColor = darkMode ? "white" : theme.textSecondaryOnPrimary;

  return (
    <LinksContainer>
      {site.linkWebsite && (
        <IconAnchor
          href={site.linkWebsite}
          target="_blank"
          key={site.linkWebsite}
          onClick={toggleDrawer}
          rel="noreferrer noopener"
        >
          <HomeIcon size={25} color={iconColor} />
        </IconAnchor>
      )}

      {site.description && (
        <IconLink
          to="/info"
          onClick={() => {
            if (isMobile) toggleDrawer();
          }}
        >
          <InfoIcon size={25} color={iconColor} />
        </IconLink>
      )}

      {site.linkFacebook && (
        <IconAnchor
          href={site.linkFacebook}
          target="_blank"
          onClick={toggleDrawer}
          rel="noreferrer noopener"
        >
          <FacebookIcon size={25} color={iconColor} />
        </IconAnchor>
      )}

      {site.linkTwitter && (
        <IconAnchor
          href={site.linkTwitter}
          target="_blank"
          onClick={toggleDrawer}
          rel="noreferrer noopener"
        >
          <TwitterIcon size={25} color={iconColor} />
        </IconAnchor>
      )}

      {site.enabledUserAccounts && (
        <>
          {hasSiteLinks && (
            <IconDividerWrapper>
              <IconDivider />
            </IconDividerWrapper>
          )}
          <IconLink to={isAuthenticated ? "/user-settings" : "/auth"}>
            <PeopleMan1Icon size={25} color={iconColor} />
          </IconLink>
        </>
      )}
    </LinksContainer>
  );
};
